import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';

import { ClaimPhotoSummary } from '@amfam/claim/photo-upload/feature';
import { DsModalService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-claim-photo-summary',
  templateUrl: './claim-photo-summary.component.html',
  styleUrls: ['./claim-photo-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ClaimPhotoSummaryComponent implements OnChanges {
  @Input() claimNumber: string;
  @Input() photoList: ClaimPhotoSummary[];
  @Input() viewPhotosAuthorized: boolean;
  @Input() uploadPhotosAuthorized: boolean;

  @Output() uploadPhotos = new EventEmitter();

  hasPhotos = false;
  showModal = false;
  modalId = 'photo-modal';
  modalPhoto: ClaimPhotoSummary = {
    url: '',
    category: '',
    description: '',
    dateCreated: ''
  };

  constructor(private modalService: DsModalService) {}

  ngOnChanges() {
    this.hasPhotos = this.photoList.length > 0;
  }

  addPhotos() {
    this.uploadPhotos.emit();
  }

  /**
   * @param: None
   * @returns: void
   * @description: Opens VIN modal
   */
  openPhotoModal(photo: ClaimPhotoSummary) {
    this.modalPhoto = photo;
    this.modalService.open(this.modalId);
  }
}
